module.exports = "/images/Croatia.png?30a74de2355e14128afa05877bf6a03a";